import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { ViewOrg, ViewOrgDefaultValues } from 'src/app/components/organization/org';
import { ModalService } from 'src/app/services/modal.service';
import { OrganizationService } from 'src/app/services/organization.service';
import { ToastService } from 'src/app/services/toast-service.service';

@Component({
    selector: 'app-view-org',
    templateUrl: './view-org.component.html',
    styleUrls: ['./view-org.component.scss'],
    standalone: false
})
export class ViewOrgComponent {
  org: ViewOrg = ViewOrgDefaultValues();
  orgid: string = '';
  modalSub!: Subscription;
  modalOpen = this._modalservice.getModalState();
  modalContent = '';
  modalTitle = '';
  modalOkButtonValue = 'OK';
  modalCancelButtonValue = 'CANCEL';
  modalOkButtonText = 'Ok';
  modalCancelButtonText = 'Cancel';
  columnsToDisplay = ['membername', 'role'];
  auditLogs: any[] = [];
  pageName = CheckPageAccess.ORGMANAGEMENT;

  constructor(
    private route: ActivatedRoute,
    private _orgservice: OrganizationService,
    private router: Router,
    private _modalservice: ModalService,
    private _toastservice: ToastService)
  { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.orgid = params['id'];
      console.log(this.orgid)
      this._orgservice.getOrgDetailsForView(params['id']).subscribe({
        next: (res) => {
          this.org = res;
        }
      });

      this._orgservice.getOrgAuditLogs(params['id']).subscribe({
        next: (res) => {
          this.auditLogs = res;
        }
      });
    });

    this.afterConfirmModalOps();
  }

  askConfirmation(
      okButtonText: string,
      okButtonValue: string,
      cancelButtonText: string,
      cancelButtonValue: string,
      content: string,
      title: string) {
    this.modalContent = content;
    this.modalTitle = title;
    this.modalOkButtonValue = okButtonValue;
    this.modalCancelButtonValue = cancelButtonValue;
    this.modalOkButtonText = okButtonText;
    this.modalCancelButtonText = cancelButtonText;

    this._modalservice.openModal();
  }

  afterConfirmModalOps() {
    this.modalSub = this._modalservice
      .getButtonClicked()
      .subscribe((button) => {
        switch (button) {
          case 'YES':
            this._orgservice.deleteOrg(this.orgid).subscribe({
              next: (response: any) => {
                this._toastservice.showMessage("Organization Deleted Successfully");
                this.router.navigate(['/org-list']);
              }
            })
            break;
          default:
            this._modalservice.closeModal();
        }
      });
  }

  ngOnDestroy(): void {
    if (this.modalSub) {
      this.modalSub.unsubscribe();
    }
  }

  deleteMaterial() {
    this.askConfirmation("Yes, Delete",
      "YES",
      "No, Cancel",
      "NO",
      "Are you sure you want to delete this Organization?",
      "Delete Organization");
  }

  navigate() {
    this.router.navigateByUrl('/edit-org/'+this.orgid);
  }
}
